<template>
  <editor-media
    ref="editor"
    formula-tipo="suma"
  >
  </editor-media>
</template>

<script>
import EditorMedia from './EditorMedia.vue';

export default {
  components: { EditorMedia },
  methods: {
    getFormulaData() {
      return this.$refs.editor.getFormulaData();
    },
  },
};
</script>
